import SubKegiatanApi from "./SubKegiatanApi";

export default SubKegiatanApi;
